module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_11-9b6ab86959565a11d1da43486cc2d95f.png";